<script setup>
import { useMapGetter } from 'dashboard/composables/store.js';

import SearchResultSection from './SearchResultSection.vue';
import SearchResultKanbanItem from './SearchResultKanbanItem.vue';

defineProps({
  kanbanItems: {
    type: Array,
    default: () => [],
  },
  query: {
    type: String,
    default: '',
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});

const accountId = useMapGetter('getCurrentAccountId');
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.KANBAN')"
    :empty="!kanbanItems.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="kanbanItems.length" class="space-y-3 list-none">
      <li v-for="item in kanbanItems" :key="item.id">
        <SearchResultKanbanItem
          :id="item.id"
          :title="item.title"
          :description="item.description"
          :contact-name="item.contactName"
          :conversation-display-id="item.conversationDisplayId"
          :created-at="item.createdAt"
          :account-id="accountId"
        />
      </li>
    </ul>
  </SearchResultSection>
</template>
